import { Typography } from "@mui/material";
import styled from "@mui/material/styles/styled";

import { lightOrDark } from "@app/embedded/theme/utils";

import ConfirmationModal, {
  ConfirmationModalProps,
} from "@rui/ConfirmationModal";

type SelfPermissionDowngradeConfirmProps = Omit<
  ConfirmationModalProps,
  "children"
>;

const Bold = styled("span")({ fontWeight: 500 });

const SelfPermissionDowngradeConfirm = (
  props: SelfPermissionDowngradeConfirmProps
) => {
  // currently the only ACL change that we show this for is Editor -> not Editor, so
  // the access level labels are hard-coded
  return (
    <ConfirmationModal {...props} title="Change your permissions?" size="md">
      <Typography
        sx={{
          color: (theme) =>
            lightOrDark("shades.neutral.600", "shades.neutral.100")(theme),
          lineHeight: 20 / 16,
        }}
      >
        When you change your own permissions from <Bold>Editor</Bold> to{" "}
        <Bold>Viewer</Bold>, you will no longer be able to edit this report or
        access report permissions.
      </Typography>
    </ConfirmationModal>
  );
};

export default SelfPermissionDowngradeConfirm;
